<script setup lang="ts">
import { listArticles } from '@/api/articles/listArticles';
import ArticleItem from '@/components/ArticleItem.vue';
import { useI18n } from 'vue-i18n';
import styles from '@/assets/sass/components/articles.module.scss';

const { t } = useI18n();

const articles = await listArticles(3);
</script>
<template>
    <section class="section">
        <div class="section__inner">
            <h2 class="section__heading section__heading--cruiser">
                {{ t('LABELS.articles') }}
            </h2>
        </div>
        <div :class="styles['article-list']">
            <ArticleItem v-for="article in articles" :key="article.id" :article="article" />
        </div>
        <div class="btn--promo-wrap">
            <RouterLink :to="{
                name: 'articleList'
            }" class="btn btn--promo btn--blue">
                {{ t('LABELS.show-all') }}
            </RouterLink>
        </div>
    </section>
</template>
